import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './index.scss';

class Step extends Component {
    render() {
        const { title, activeStep, count } = this.props;
        const stepClass = classNames({
            [styles.active]: activeStep,
            [styles.step]: true,
        });

        return (
            <div className={stepClass}>
                <span className={styles.stepCircle}>{count}</span>
                <span className={styles.stepTitle}>{title}</span>
                <div className={styles.stepBorder} />
            </div>
        );
    }
}

Step.propTypes = {
    activeStep: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    active: PropTypes.bool,
    count: PropTypes.number.isRequired,
};

Step.defaultProps = {
    activeStep: '',
    steps: '',
    count: '',
};

export default Step;
